import { ImportExportHistory } from '@/features/import_export_histories';
import { FC, memo } from 'react';
import { useLocation } from 'react-router-dom';

const ImportExportHistoryCustomTransactionItemsPage: FC = memo(() => {
  const location = useLocation();

  return <ImportExportHistory location={location} />;
});

ImportExportHistoryCustomTransactionItemsPage.displayName =
  'ImportExportHistoryCustomTransactionItemsPage';

export default ImportExportHistoryCustomTransactionItemsPage;
